var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"placeholder absolute pointer-events-none text-sm md:text-base top-[17px] text-gray-100",class:{ [`${_vm.theme || 'white'}`]: true },attrs:{"for":_vm.idFor}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }